import { ThemeProvider } from '@volkswagen-onehub/components-core';
import React, { useEffect } from 'react';
import { Provider, connect } from 'react-redux';
import { handleOffers } from 'src/bff';
import { OffersFeatureAppConfig } from './feature-app';
import HomePage from './pages/HomePage';
import OfferPage from './pages/OfferPage';
import { CarouselPage } from './pages';
import { useFaContent } from './hooks/use-fa-content';
import { applyMiddleware, createStore } from 'redux';
import { OffersState, offersReducer } from './redux/reducer';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import { isCallCenterOpen } from './utils';

interface OffersAppProps {
  initialState: OffersState;
  config: OffersFeatureAppConfig;
}

declare global {
  var s: { persCmp?: string };

  export interface Window {
    dataLayer: any[];
  }
}

export function OffersApp(props: OffersAppProps) {
  const { initialState, config } = props;
  const isFilter = config.mode === 'filter' ? true : false;
  const isCarousel = config.mode === 'carousel' ? true : false;
  const faContent = useFaContent();
  

  const store = createStore(offersReducer, initialState, composeWithDevTools(applyMiddleware(thunkMiddleware)));

  const getOfertas = async () => {
    const initialState = await handleOffers(faContent);
    store.dispatch({ type: 'UPDATE_STATE', payload: initialState });
  };

  useEffect(() => {
    if (initialState.offers.length === 0 && !isFilter) {
      getOfertas();
    } else if (initialState.offers.length > 0 && !isFilter) {
      store.dispatch({ type: 'UPDATE_STATE', payload: initialState });
    }
    
    isCallCenterOpen().then((response) => {
      store.dispatch({ type: 'IS_CALL_CENTER_OPEN', payload: response });      
    });
    return;
  }, [initialState]);

  return (
    <Provider store={store}>
      <ThemeProvider theme={faContent.theme ? faContent.theme : 'main'}>{ isFilter ? <OfferPage /> : isCarousel ? <CarouselPage/> : <HomePage />}</ThemeProvider>
    </Provider>
  );
}
